/**
 * Pluralize a human-readable entity label for counts and placeholders.
 * Handles consonant + y → ies (priority → priorities, strategy → strategies).
 */
export function pluralizeEntityLabel(label: string, count = 2): string {
  if (count === 1) return label;

  const trimmed = label.trim();
  const lastSpace = trimmed.lastIndexOf(' ');
  const prefix = lastSpace >= 0 ? trimmed.slice(0, lastSpace + 1) : '';
  const lastWord = lastSpace >= 0 ? trimmed.slice(lastSpace + 1) : trimmed;

  if (/[^aeiou]y$/i.test(lastWord)) {
    return `${prefix}${lastWord.slice(0, -1)}ies`;
  }
  if (/(s|x|z|ch|sh)$/i.test(lastWord)) {
    return `${prefix}${lastWord}es`;
  }
  return `${prefix}${lastWord}s`;
}
